export const figure28 = { 
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'column',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},
colors: ['#bfbfbf','#ff0000','#00b050'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
},
column: {
stacking: 'percent'
}
},

exporting: {
enabled: false
},


xAxis: [{
categories: [ "África subsahariana", "Oceanía (excluidas Australia y Nueva Zelandia)", "Asia central y meridional", "África septentrional y Asia occidental", "América Latina y el Caribe", "Asia oriental y sudoriental", "Europa y América septentrional", "Australia y Nueva Zelandia", "Mundo" ],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 16,
labels: {
style: {
	       textOverflow: 'none',
	       fontWeight: 'normal',
color: '#999999',
fontSize: '12px',
}
},
}],
yAxis: {
labels: {
style: {
	   textOverflow: 'none',
	   fontWeight: 'normal',
	   color: '#999999',
	   fontSize: '12px',
format: '{value}',
formatter: function () {
// should be return this.value + '.00%'; but doesn't fit
	    return this.value + '';
    },
   },
},
min: 0,
max: 100,
tickInterval: 20,
title: {
text: ''
}
},
tooltip: {
pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
shared: true
},
legend: {
enabled: false,
},

series: [
{
name: 'Razas locales con un nivel de riesgo desconocido',
color: '#bfbfbf',
data: [ 659, 64, 558, 412, 472, 992, 1213, 24, 4394 ]
},
{
name: 'Razas locales en riesgo',
color: '#ff0c00',
data: [ 78, 0, 151, 65, 59, 88, 353, 9, 803]
},
{
name: 'Razas locales sin riesgo',
color: '#0eb050',
data: [ 37, 0, 34, 21, 37, 53, 1631, 58, 1871 ]
},

]
}
